import React from 'react'

import { useModalContext } from 'hooks/modal-context'

import Modal from 'shared/Modal/Modal'
import Slider from 'shared/Slider/Slider'

interface Datas {
  datas: {
    allFlamelinkGalleryContent: {
      nodes: {
        id: number
        alt: string
        width: number
        height: number
        image: {
          url: string
        }[]
      }[]
    }
  }
}

const s = {
  group: `w-full h-full`,
  count: `absolute top-2 right-4 z-2 mb-0 text-base text-white`,
  image: `w-full h-full object-cover`,
}

const Image = ({ datas }: Datas) => {
  const { openModal } = useModalContext()

  const images = datas.allFlamelinkGalleryContent.nodes

  return (
    <Modal openModal={openModal}>
      <Slider autoPlay={false}>
        {images.flatMap(({ alt, width, height, image }) =>
          image.map(({ url }, idx) => (
            <div key={idx} className={s.group}>
              <img
                className={s.image}
                src={url}
                alt={alt}
                width={width}
                height={height}
              />

              <p className={s.count}>{`${idx + 1} of ${image.length}`}</p>
            </div>
          ))
        )}
      </Slider>
    </Modal>
  )
}

export default Image
